import React from 'react';
import { LoadingPage } from '../../Shared';

export const LogoutScreen = ({ subtext }: { subtext?: string }) => (
  <LoadingPage subtext={subtext} fullscreen />
);
